// extracted by mini-css-extract-plugin
export default {"dialogTitle":"dialog_dialogTitle__1zUhJ","close":"dialog_close__mGq+c","dialogueContent":"dialog_dialogueContent__39cgH"};